import { Controller } from "@hotwired/stimulus"
import {
  CategoryScale,
  Chart,
  Filler,
  Legend,
  LineController,
  LineElement,
  LinearScale,
  PointElement,
  Tooltip
} from "chart.js"
import { weatherTooltipPlugin } from "./chart_weather_tooltip"

Chart.register(CategoryScale, Filler, Legend, LineController, LineElement, LinearScale, PointElement, Tooltip)

const PX_PER_DAY_2WEEKS = 60

export default class extends Controller {
  static targets = ["canvas"]
  static values = {
    labels: Array,
    values: Array,
    color: String,
    fillColor: String,
    unit: String,
    weather: Array,
    period: String
  }

  connect() {
    const weather = this.weatherValue

    if (this.periodValue === "2weeks") {
      this.setupScrollableChart()
    }

    this.chart = new Chart(this.canvasTarget, {
      type: "line",
      data: {
        labels: this.labelsValue,
        datasets: [
          {
            data: this.valuesValue,
            borderColor: this.colorValue,
            backgroundColor: this.fillColorValue,
            pointBackgroundColor: this.colorValue,
            pointBorderColor: this.colorValue,
            pointRadius: 3,
            pointHoverRadius: 5,
            borderWidth: 2,
            fill: true,
            tension: 0.3,
            spanGaps: false
          }
        ]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        animation: false,
        plugins: {
          legend: { display: false },
          tooltip: weatherTooltipPlugin(weather, this.labelsValue, (dp) => {
            const val = dp.parsed.y
            if (val === null || val === undefined) return ""
            const rounded = Number.isInteger(val) ? val : parseFloat(val.toFixed(1))
            return `${rounded} ${this.unitValue}`
          })
        },
        scales: {
          x: {
            grid: { display: false },
            title: {
              display: true,
              text: "(日)",
              font: { size: 10 }
            },
            ticks: {
              font: { size: 10 },
              maxRotation: 0
            }
          },
          y: {
            beginAtZero: true,
            grid: { color: "#ECECEC" },
            title: {
              display: true,
              text: `(${this.unitValue})`,
              font: { size: 10 }
            },
            ticks: {
              font: { size: 10 }
            }
          }
        }
      }
    })

    if (this.periodValue === "2weeks") {
      this.scrollToEnd()
    }
  }

  setupScrollableChart() {
    const container = this.element
    const existing = container.querySelector("[data-scrollable-wrapper]")
    if (existing) {
      existing.style.width = `${this.labelsValue.length * PX_PER_DAY_2WEEKS}px`
      return
    }
    container.style.overflowX = "auto"
    const wrapper = document.createElement("div")
    wrapper.style.height = "100%"
    wrapper.style.width = `${this.labelsValue.length * PX_PER_DAY_2WEEKS}px`
    wrapper.setAttribute("data-scrollable-wrapper", "")
    container.appendChild(wrapper)
    wrapper.appendChild(this.canvasTarget)
  }

  scrollToEnd() {
    this.element.scrollLeft = this.element.scrollWidth
  }

  disconnect() {
    if (this.chart) {
      this.chart.destroy()
      this.chart = null
    }
    const wrapper = this.element.querySelector("[data-scrollable-wrapper]")
    if (wrapper) {
      wrapper.remove()
    }
  }
}
